<template>
    <WidgetCard
        :icon="`${locationItem?.icon} q-mr-sm`"
        :title="$t(locationItem.titleKey)"
        :description="$t(locationItem.textKey)"
    >
        <template #button>
            <div class="flex justify-end">
                <AdvancedRouterLink
                    class="router-link"
                    :to="locationItem.getButtonRoute?.()"
                    :click-handler="locationItem.buttonClickEvent"
                    :disabled="!locationItem.isActive"
                >
                    <template #content>
                        <QitButton
                            class="installation-location-item-button"
                            :label="$t(locationItem.buttonTextKey)"
                            :disabled="!locationItem.isActive"
                            :data-qs="`installation-location-button-${locationItem.locationKey}`"
                            :no-wrap="false"
                        />
                    </template>
                </AdvancedRouterLink>
            </div>
        </template>
    </WidgetCard>
</template>

<script setup lang="ts">
import { InstallationLocationItem } from "@/abilities/mechanic/pages/widgets/installation-location.model";
import AdvancedRouterLink from "@/shared/components/router-link/advanced-router-link.vue";
import QitButton from "@/shared/components/buttons/qit-button.vue";
import WidgetCard from "@/shared/components/widgets/widget-card.vue";

defineProps<{
    locationItem: InstallationLocationItem;
}>();
</script>
